/*
 * File: backup.service.ts                                                     *
 * Project: catalog-cloud                                                      *
 * File Created: Thursday, 16th June 2022 13:26:16                             *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Friday, 2nd December 2022 14:20:26                           *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ApiService } from '../../api/services/api.service';

import { environment } from 'environment';

@Injectable({
  providedIn: 'root',
})
export class BackupService {
  private get baseUrl(): string { return this.api.getBaseUrl(); }
  private baseApi = "/api/v1/";
  private endpoints = {
    list: 'backups/list',
    ondemand: 'backups/ondemand',
    restore: 'backups/restore',
    download: 'backups/download',

  };
  backuplist$: Subject<any> = new Subject<any>();
  constructor (private api: ApiService) {

  }

  getList() {
    const endpoint = this.baseUrl + this.baseApi + this.endpoints.list;
    
    this.api.get(endpoint).subscribe((data: any) => {
      
      this.backuplist$.next(data);
    });
  }

  createBackup(userId: string) {
    this.api.post(this.baseUrl + this.baseApi + this.endpoints.ondemand, { id: userId }).subscribe((data) => {
      this.getList();
      // this.popup.addMessage('info', 'Backup guardado con éxito');
    });
  }

  restore(idBackup: string) {
    return this.api.post(this.baseUrl + this.baseApi + this.endpoints.restore, { id: idBackup });
  }

  download(idBackup: string) {
    let endpoint = this.baseApi + this.endpoints.download + '/' +idBackup;
    
    return this.api.getFile(this.baseUrl + endpoint);
  }

  authDropbox() {
    let endpoint = '/dropbox';
    return this.api.get(this.baseUrl + endpoint);
  }
}
